/**
 * @author Ilya Aderiho
 */
var ReportNewClients1Controller = (function () {
    function ReportNewClients1Controller(env, socket, $scope, admin, settings, $filter) {
        var _this = this;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.settings = settings;
        this.$filter = $filter;
        this.clients = [];
        this.clientsLoaded = false;
        this.visible = false;
        this.err = { error: false, message: '' };
        this.excel = { downloaded: false, loaded: false, err: false };
        this.table = {};
        this.exportFired = false;
        this.viewLog = false;
        // DOWNLOAD EXCEL (user example)
        this.socket.forward('admin.approvedList.export', this.$scope);
        this.$scope.$on('socket:admin.approvedList.export', function (event, data) {
            _this.exportFired = false;
            if (!data.payload.error) {
                _this.file = data;
                _this.file.fileName = 'DMT_NEW_APPROVED_CLIENTS_list.xlsx';
                _this.file.fileSize = _this.file.payload.byteLength;
                if (_this.file.fileSize < 1000000) {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000, 2) + 'KB';
                }
                else {
                    _this.file.fileSize = $filter('number')(_this.file.fileSize / 1000000, 2) + 'MB';
                }
                _this.excel.err = false;
                _this.excel.loaded = true;
            }
            else {
                _this.err.error = true;
                _this.excel.err = true;
                _this.err.message = data.error;
            }
        });
    }
    ReportNewClients1Controller.prototype.toggle = function () {
        this.visible = !this.visible;
        if (this.visible) {
            this.exportClientExcel();
        }
    };
    ReportNewClients1Controller.prototype.exportClientExcel = function () {
        this.exportFired = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: {},
                email: this.env.user.email,
                function: 'exportToExcel',
                scopeBack: 'admin.approvedList.export',
                script: 'admin/approvedlist/approved-list',
                token: this.env.user.token
            }
        });
    };
    ReportNewClients1Controller.prototype.downloadExcelSpreadsheet = function () {
        this.exportFired = true;
        var a = document.createElement('A');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none;');
        var url = window.URL.createObjectURL(new Blob([this.file.payload], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        a.setAttribute('href', url);
        var d = new Date().toDateString();
        a.setAttribute('download', "DMT-NEW-APPROVED-CLIENTS_" + d + ".xlsx");
        a.click();
        this.exportFired = false;
        this.excel.downloaded = true;
    };
    ReportNewClients1Controller.$inject = ['env', 'socket', '$scope', 'admin', 'settings', '$filter'];
    return ReportNewClients1Controller;
}());
var ReportNewClientsComponent = (function () {
    function ReportNewClientsComponent() {
        this.templateUrl = 'report-newclients.html';
        this.controller = ReportNewClients1Controller;
    }
    return ReportNewClientsComponent;
}());
angular
    .module('application')
    .component('reportNewclients', new ReportNewClientsComponent());

//# sourceMappingURL=reporting.newclients.component.js.map
